<template>
    <p v-if="file_path">
        <img
            v-if="file_type === 'image' && show_file == true"
            :src="file_path"
        />

        <a
            v-if="file_type === 'file' && show_file == true"
            :href="file_path"
            target="_blank"
        >
            {{ file_path.split("\\").pop().split("/").pop() }}
        </a>

        <a @click="showModal = true" v-if="show_file == true" class="danger">
            <font-awesome-icon :icon="['fas', 'fa-trash']" />
            Supprimer
        </a>
        <Teleport to="body">
            <Modal :show="showModal">
                <template v-slot:header>
                    <p>Supprimer ?</p>
                </template>

                <template v-slot:footer>
                    <button @click="deleteFile()" class="danger">
                        Supprimer
                    </button>
                    <a @click="showModal = false">Annuler</a>
                </template>
            </Modal>
        </Teleport>
    </p>

    <div class="container-file-picker">
        <input type="file" @input="handleInput" />
        <span class="file-picker"
            ><font-awesome-icon :icon="['fas', 'fa-file']" />
            {{ text_choose_file }}</span
        >
    </div>
</template>

<script setup>
//@update:modelValue="handleInput"
import { ref } from "vue";
import axios from "axios";
import Modal from "@inertia/Modals/Modal.vue";
import { useToast } from "vue-toastification";

const props = defineProps({
    context: Object,
});

const value = ref(props.context.value || "");
const file_path = ref(props.context.file_path || false);

const file_type = ref(props.context.file_type || false);
const delete_url = ref(props.context.delete_url || false);

let showModal = ref(false);
let show_file = ref(true);

let text_choose_file = ref("Choisir un fichier");

function handleInput(e) {
    if (e.target && e.target.files) {
        props.context.node.input(e.target.files[0]);
        text_choose_file.value = e.target.files[0].name;
        console.log(e.target.files[0]);
    }
}

const toast = useToast();

const deleteFile = () => {
    axios.post(delete_url.value).then((response) => {
        if (response.data.status == "success") {
            showModal.value = false;
            show_file.value = false;
            toast.success("L'image a été supprimé", {
                timeout: 2000,
            });
        }
    });
};
</script>

<style scoped>
p {
    margin-bottom: 0.5rem;
}
a {
    display: block;
}

.container-file-picker {
    position: relative;
    margin-bottom: 1rem;
}
.container-file-picker span {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    border: 1px solid #a2afb9;
    padding: 0.8rem;
    border-radius: 0.25em;
}

input[type="file"] {
    appearance: none;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    color: transparent;
    cursor: pointer;
    display: block;
}

input[type="file"]::file-selector-button {
    appearance: none;
    font-size: 0;
    border: 0;
    visibility: hidden;
}
</style>
